import { render, staticRenderFns } from "./RowInfoDetail.vue?vue&type=template&id=0a70e916&scoped=true&"
import script from "./RowInfoDetail.vue?vue&type=script&lang=js&"
export * from "./RowInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./RowInfoDetail.vue?vue&type=style&index=0&id=0a70e916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70e916",
  null
  
)

export default component.exports